<template>
  <div id="sportsDetail_medal" v-show="currThemeObj">
    <div class="select_area" :class="isEditBtnFlag ? 'show' : 'hide'">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        :settingInputVal="curInputVal"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="abs_btnArea" :class="isEditBtnFlag ? 'show' : 'hide'">
      <span
        class="editBtnArea"
        v-if="
          mixtmt_userInfo &&
          mixtmt_userRoleKeyList.includes(userRoleKey_editMedal)
        "
      >
        <template v-if="!isEditBtnFlag">
          <span class="editBtnItem" @click="clickEditBtn(isEditBtnFlag)">
            <span class="editBtn" v-text="'编辑奖牌'"></span>
            <span class="btnIconBox">
              <svg
                t="1692698307306"
                class="btnIconBox_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="74%"
                height="74%"
              >
                <path
                  d="M631.808 100.864H187.904c-69.12 0-126.464 54.784-126.464 122.88v611.328c0 68.096 56.832 122.88 126.976 122.88h632.832c70.144 0 126.976-54.784 126.976-122.88V409.088h-63.488v425.984c0 34.304-28.672 61.44-64 61.44H188.416c-35.328 0-64-27.648-64-61.44V223.744c0-33.792 28.672-61.44 62.976-61.44h443.904v-61.44z"
                  p-id="4184"
                ></path>
                <path
                  d="M459.264 507.392c-6.144 5.632-9.216 13.312-9.216 21.504s3.584 15.872 9.216 21.504c12.288 11.776 32.256 11.776 45.056 0L952.32 117.76c6.144-5.632 9.216-13.312 9.216-21.504s-3.584-15.872-9.216-21.504c-12.288-11.776-32.256-11.776-45.056 0L459.264 507.392z"
                  p-id="4185"
                ></path>
              </svg>
            </span>
          </span>
        </template>
        <template v-if="isEditBtnFlag">
          <span class="editBtnItem small cancel" @click="medalBtnCancel()">
            <span class="editBtn" v-text="'取消'"></span>
          </span>
          <span class="editBtnItem small" @click="medalBtnOk()">
            <span class="editBtn" v-text="'保存'"></span>
          </span>
        </template>
      </span>
      <span
        class="shareBtnArea"
        @click="clickPublicTheme(eventMedalItem, 'all')"
      >
        <span class="shareBtn" v-text="'小项奖牌'"></span>
        <span class="publishBtn">
          <svg
            t="1692698307306"
            class="publishBtn_icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="9670"
            width="80%"
            height="80%"
          >
            <path
              d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
              p-id="9671"
            ></path>
          </svg>
        </span>
      </span>
    </div>
    <div class="teamTable" :class="isEditBtnFlag ? 'show' : 'hide'">
      <div class="tableScrollArea" ref="tableParentDom">
        <div class="fixed_label">
          <div class="medalList_item">
            <span
              class="medalType"
              :class="isEditBtnFlag ? 'edit' : ''"
              v-text="'奖牌'"
            ></span>
            <span class="rankNum" v-text="'排名'"></span>
            <span
              class="playerList"
              v-if="['A', 'D'].includes(medalListMode)"
              :class="medalListMode"
              v-text="'运动员'"
            ></span>
            <span class="delegation" v-text="'代表团'"></span>
          </div>
        </div>
        <div :class="scrollDomClassName">
          <div
            class="medalList_item"
            v-for="(item, rankIndex) in medalList"
            :key="rankIndex"
          >
            <span class="medalType" :class="isEditBtnFlag ? 'edit' : ''">
              <template v-if="isEditBtnFlag">
                <span
                  class="theme_select"
                  :class="item.editMedalType ? 'selectVal' : ''"
                >
                  <el-select
                    v-show="medalEditList && medalEditList.length > 0"
                    v-model="item.editMedalType"
                    placeholder="请选择"
                    popper-class="theme_select_popper"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="cell in medalEditList"
                      :key="cell.value"
                      :label="cell.name"
                      :value="cell.value"
                    ></el-option>
                  </el-select>
                </span>
              </template>
              <template v-else>
                <span class="icon" :class="item.medalType"></span>
              </template>
            </span>
            <span class="rankNum" v-text="item.rankNum"></span>
            <span
              class="playerList"
              v-if="['A', 'D'].includes(medalListMode)"
              :class="medalListMode"
            >
              <span
                class="playerList_item"
                v-for="player in item.playerList"
                :key="player.id"
              >
                <span
                  class="playerLogo"
                  :class="player.playerLogo ? 'isLogo' : ''"
                >
                  <img v-if="player.logo" :src="player.logo" />
                </span>
                <span class="playerName" v-text="player.name"></span>
              </span>
            </span>
            <span class="delegation">
              <span
                class="delegationLogo"
                :class="item.delegationLogo ? 'isLogo' : ''"
              >
                <img v-if="item.delegationLogo" :src="item.delegationLogo" />
              </span>
              <span class="delegationName" v-text="item.delegationName"></span>
            </span>
            <span
              v-if="item.medalType"
              class="publishBtn"
              @click="clickPublicTheme(item, 'single')"
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <baseDialog
      v-if="isBaseDialog"
      :currThemeObj="currThemeObj"
      :isDialogFlag="isBaseDialog"
      :dialogObj="baseDialogObj"
      @baseDialogEvent="baseDialogHandler"
    ></baseDialog>
  </div>
</template>

<script>
import {
  https_sportsEvent_medalList,
  https_editMedalTally,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import baseDialog from '@components/platfromBase/compreSportsMeet/baseDialog.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
export default {
  name: 'sportsDetail_medal',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    BackTop,
    marathon_select_opt,
    baseDialog,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    currSportsDetail: {
      handler(newVal, oldVal) {
        console.debug('重新刷新数据1:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入代表团/运动员名称',
        iconType: 'country',
      }, //控制marathon_select_opt中的输入框是否显示
      curInputVal: '',
      selectOptData: {
        configArr: [],
        selectOpt_list: [],
      },
      medalListMode: '', //默认团队
      isScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      medalList: null,
      total: 0,
      showBackTop: false,
      eventMedalItem: null,
      medalEditList: [
        {
          value: 'ME_GOLD',
          name: '金牌',
        },
        {
          value: 'ME_SILVER',
          name: '银牌',
        },
        {
          value: 'ME_BRONZE',
          name: '铜牌',
        },
        {
          value: '',
          name: '未获奖',
        },
      ],
      isEditBtnFlag: false,
      loadSaveingFlag: false, //保存时，【取消】按钮不能点击
      isBaseDialog: false,
      baseDialogObj: null,
      userRoleKey_editMedal: 'editMedal',
      themeTemplateType: 11,
    }
  },
  beforeCreate() {},
  created() {
    this.query = this.$route.query
    if (this.currGroup) {
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    noMore() {
      // return this.total !== 0 && this.isScrollBottom
      return this.total !== 0
    },
    noData() {
      return this.medalList && this.medalList.length == 0
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      this.getUserRoleList()
      this.makeAnalysisItemParams(this.themeTemplateType)
      await this.getSportsEventPlayerList()
      console.debug(this.stageArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async medalBtnCancel() {
      // 退出编辑模式 且 重新拉取数据
      if (!this.loadSaveingFlag) {
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
        this.curInputVal = ''
        this.clickEditBtn(this.isEditBtnFlag)
        this.getSportsEventPlayerList() //重新拉一次数据
        window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      }
    },
    async medalBtnOk() {
      this.baseDialogObj = {
        dialogType: '',
        dialogText: '请确认是否【保存】并提交修改后的数据',
        mid: 0,
      }
      this.isBaseDialog = true
      console.debug('medalBtnOk:', this.isBaseDialog)
    },
    async baseDialogHandler(data) {
      console.debug('baseDialogHandler:', data)
      // 无论有没有数据都要将值赋值为false
      this.isBaseDialog = false
      if (data && data.flag) {
        this.loadSaveingFlag = true
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
        let actMedalList = []
        const medalNumArr = ['ME_GOLD', 'ME_SILVER', 'ME_BRONZE']
        this.medalList.forEach((item) => {
          let medalNum = medalNumArr.indexOf(item.editMedalType) + 1
          if (medalNum > 0) {
            actMedalList.push({
              competitorCode: item.competitorCode,
              medalNum,
              organisationCode: item.delegationId,
              competitorType: this.medalListMode,
            })
          }
        })
        await this.postEditMedalTally(actMedalList) //保存修改
        this.loadSaveingFlag = false
        this.medalBtnCancel()
        console.debug(this.stageArr)
        window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      }
      this.baseDialogObj = null
    },
    clickEditBtn(flag) {
      this.isEditBtnFlag = !flag
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.init()
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'compreSportsMeet',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      console.debug('resData:', resData)
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.analysisItem =
          this.themeList && this.themeList[0] ? this.themeList[0] : null
        this.eventMedalItem =
          this.themeList && this.themeList[1] ? this.themeList[1] : null
      } else {
        this.themeList = []
        this.analysisItem = null
        this.eventMedalItem = null
      }
    },
    clickPublicTheme(item, type) {
      // 分享主题
      console.debug('item:', item)
      let themeItem = null
      if (type === 'all') {
        themeItem = JSON.parse(JSON.stringify(this.eventMedalItem))
      } else {
        themeItem = JSON.parse(JSON.stringify(this.analysisItem))
      }
      themeItem.sportsId = this.currSportsDetail.sportsId
      themeItem.eventId = this.currSportsDetail.eventId
      themeItem.phaseId = 0
      themeItem.actJson = {
        medalType: item.medalType,
        competitorCode: item.competitorCode,
      }
      // const query = this.$route.query
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: themeItem,
        mid: 0,
      })
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // console.debug(
      //   'this.parentWidthPx:',
      //   this.$refs.tableParentDom.scrollHeight
      // )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        const scrollTop = this.scrollAreaDom.scrollTop
        const scrollHeight = this.scrollAreaDom.scrollHeight
        const parentHeightPx = this.scrollAreaDom.offsetHeight
        let direction = this.DIRECTION_ENUM.DOWN
        if (this.beforeScrollTop > scrollTop) {
          direction = this.DIRECTION_ENUM.UP
        }
        // 通过滚动方向判断是触底还是触顶
        // console.debug(
        //   'direction:',
        //   direction,
        //   scrollTop,
        //   parentHeightPx,
        //   scrollHeight,
        //   this.isScrollBottom
        // )

        if (scrollTop > 300) {
          this.showBackTop = true
        } else {
          this.showBackTop = false
        }

        if (direction == this.DIRECTION_ENUM.DOWN) {
          // 滚动触底
          if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
            console.debug('滚动触底')
            this.isScrollBottom = true
          }
        } else {
          // 滚动到顶部
          this.isScrollBottom = false
          if (scrollTop <= this.threshold) {
            console.debug('滚动到顶部')
          }
        }

        this.beforeScrollTop = this.scrollAreaDom.scrollTop
      })
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    async getSportsEventPlayerList() {
      await https_sportsEvent_medalList(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        sid: this.currSid,
        eventId: this.currSportsDetail.eventId,
        name: this.curInputVal,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let medalListMode = res.data.competitorType
                ? res.data.competitorType
                : 'T' //默认T
              this.total = res.data.dataLit ? res.data.dataLit.length : 0
              this.medalList = res.data.dataLit
                ? res.data.dataLit.map((item) => {
                    return {
                      delegationId: item.organisationCode,
                      delegationLogo: item.organisationLogo,
                      delegationName: item.organisationName,
                      rankNum: item.rankNum,
                      medalType: item.medalType,
                      editMedalType: item.medalType ? item.medalType : '',
                      competitorCode: item.competitorCode,
                      playerList: item.athleteInfos
                        ? item.athleteInfos.map((player) => {
                            return {
                              id: player.athleteCode,
                              name: player.athleteName,
                              logo: player.athleteLogo,
                            }
                          })
                        : [],
                      // type:
                      //   item.athleteInfos && item.athleteInfos.length > 2
                      //     ? 'delegation'
                      //     : 'player',
                    }
                  })
                : []
              this.medalListMode = medalListMode
              this.initScroll()
            } else {
              console.debug('暂无数据')
            }
            if (this.total === 0) {
              this.medalList = []
            } else {
              this.$nextTick(() => {
                this.loading = false
              })
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async postEditMedalTally(medalListStr) {
      await https_editMedalTally(this.axiosBaseUrl, this.$axios, {
        cCode: this.currCid,
        sCode: this.currSid,
        disciplineCode: this.currSportsDetail.sportsId,
        eventCode: this.currSportsDetail.eventId,
        medalListStr: JSON.stringify(medalListStr),
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#sportsDetail_medal {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    transition: height 0.3s linear;
    overflow: hidden;
    &.hide {
      height: 0;
    }
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .abs_btnArea {
    position: absolute;
    top: 30.5vw;
    right: 9.722vw;
    z-index: 2;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    transition: top 0.3s linear;
    &.hide {
      top: 21.5vw;
    }
    .shareBtnArea {
      width: 9.74vw;
      height: 3.2vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      background-color: var(--mixtmt_subColor1_1);
      border: 1px solid var(--mixtmt_subColor1_1);
      border-radius: 0.347vw;
      color: var(--mixtmt_whiteColor);
      transition: all 0.3s linear;
      .shareBtn {
        font-size: 1.11vw;
      }
      .publishBtn {
        width: 1.8vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }

    .editBtnArea {
      width: auto;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;

      .editBtnItem {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 9.74vw;
        height: 3.2vw;
        background-color: var(--mixtmt_subColor1_1);
        border: 1px solid var(--mixtmt_subColor1_1);
        color: var(--mixtmt_whiteColor);
        border-radius: 0.347vw;
        transition: all 0.3s linear;
        margin-right: 1.388vw;
        &.small {
          width: 5.55vw;
          &.cancel {
            background-color: var(--mixtmt_whiteColor);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
          }
        }
      }
      .editBtn {
        font-size: 1.11vw;
      }
      .btnIconBox {
        width: 1.8vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.btnIconBox_icon {
          fill: var(--mixtmt_whiteColor);
          /* fill: var(--mixtmt_greyColor2); */
        }
      }
    }
  }

  .teamTable {
    padding: 4.8vw 0 6.964vw;
    transition: padding 0.3s linear;
    &.hide {
      padding: 0 0 6.964vw;
    }
    .tableScrollArea {
      position: relative;
      .fixed_label {
        .medalList_item {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.778vw;
          color: var(--mixtmt_greyColor4);
          .medalType {
            width: 4.86vw;
            font-size: 0.972vw;
            text-align: center;
            transition: width 0.3s linear;
            &.edit {
              width: 8.33vw;
            }
          }
          .rankNum {
            width: 5.55vw;
            font-size: 0.972vw;
            text-align: center;
          }
          .playerList {
            width: 38.8vw;
            font-size: 0.972vw;
            padding-left: 2.083vw;
          }
          .delegation {
            flex: 1;
            font-size: 0.972vw;
            padding-left: 2.083vw;
          }
          .theme_select {
            width: 9.027vw;
            margin-right: 1.388vw;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .scrollDomContain {
        /* max-height: calc(100vh - 19.142vw);
        overflow: auto; */
        .medalList_item {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 3.88vw;
          color: var(--mixtmt_greyColor2);
          border-bottom: 1px solid var(--mixtmt_greyColor8);
          .medalType {
            width: 4.86vw;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            padding: 0 0.694vw;
            transition: width 0.3s linear;
            &.edit {
              width: 8.33vw;
            }
            .icon {
              display: block;
              width: 1.805vw;
              height: 1.805vw;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              &.ME_GOLD {
                background-image: var(--mixtmt_gold_num_icon);
              }
              &.ME_SILVER {
                background-image: var(--mixtmt_silver_num_icon);
              }
              &.ME_BRONZE {
                background-image: var(--mixtmt_bronze_num_icon);
              }
            }
          }
          .rankNum {
            width: 5.55vw;
            padding: 0 1.38vw;
            font-size: 1.11vw;
            text-align: center;
          }
          .playerList {
            width: 38.8vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            &.A {
              .playerList_item {
                width: 100%;
              }
            }
            &.D {
              .playerList_item {
                width: 50%;
              }
            }
            .playerList_item {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              padding-right: 1.041vw;
              .playerLogo {
                width: 2.083vw;
                height: 2.569vw;
                overflow: hidden;
                background-image: var(--mixtmt_default_playerLogo);
                background-size: 100% auto;
                background-repeat: no-repeat;
                background-position: center bottom;
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                &.isLogo {
                  background-image: none;
                }
              }
              .playerName {
                width: calc(100% - 2.083vw);
                font-size: 1.11vw;
                padding: 0 0.556vw;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
          .delegation {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: 1.388vw;
            .delegationLogo {
              width: 2.083vw;
              height: 1.38vw;
              overflow: hidden;
              background-color: var(--mixtmt_greyColor0);
              &.isLogo {
                background-color: transparent;
              }
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            .delegationName {
              font-size: 1.11vw;
              padding: 0 2.083vw 0 0.556vw;
            }
          }
          .publishBtn {
            width: 3.2vw;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            svg.publishBtn_icon {
              fill: var(--mixtmt_greyColor4);
            }
          }
        }
      }
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}

.mixtmt_pc #sportsDetail_medal {
  .shareBtnArea,
  .editBtnArea .editBtnItem,
  .editBtnArea .editBtnItem.cancel {
    &:hover {
      cursor: pointer;
      background-color: var(--mixtmt_mainColor);
      border: 1px solid var(--mixtmt_mainColor);
      color: var(--mixtmt_whiteColor);
    }
  }
  .scrollDomContain {
    .medalList_item {
      &:hover {
        /* cursor: pointer; */
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_mainColor);
        .publishBtn {
          svg.publishBtn_icon {
            fill: var(--mixtmt_whiteColor);
          }
        }
        .publishBtn {
          &:hover {
            cursor: pointer;
            svg.publishBtn_icon {
              fill: var(--mixtmt_mainColor5);
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#sportsDetail_medal {
  .theme_select {
    .el-select {
      .el-input {
        font-size: 0.972vw;
        .el-input__inner {
          height: 2.083vw;
          padding: 0 2.083vw 0 0.694vw;
          line-height: calc(2.083vw - 2px);
          border-radius: 0.278vw;
          &:focus,
          &:active {
            border-color: var(--mixtmt_mainColor8);
          }
        }
        .el-select__caret {
          font-size: 0.927vw;
        }
        .el-input__icon {
          width: 0.694vw;
          line-height: 2.083vw;
        }
      }
      .el-icon-arrow-up::before {
        content: '\e79a';
      }
    }
  }
  .el-select-dropdown__empty {
    padding: 1.11vw;
    font-size: 0.972vw;
  }
}

.mixtmt_pc .theme_select {
  &.selectVal .el-select {
    .el-input__inner {
      font-weight: bold;
      color: var(--mixtmt_mainColor8);
    }
  }
  .el-select {
    &:hover {
      .el-input__inner,
      .el-icon-arrow-up::before {
        color: var(--mixtmt_mainColor8);
      }
      .el-input__inner {
        border-color: var(--mixtmt_mainColor8);
      }
    }
  }
}
.theme_select_popper {
  .el-select-dropdown__item {
    font-size: 0.972vw;
    padding: 0 1.042vw;
    height: 2.778vw;
    line-height: 2.778vw;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover,
  .el-select-dropdown__item.selected {
    color: var(--mixtmt_subColor1_1);
    background-color: var(--mixtmt_subColor1_2);
  }
}
</style>
